import { SellerFilterOption } from '@/components/SellerFilter/SellerFilterUi';
import cacheKeys from '@/data/api/cacheKeys';
import { getProducts } from '@/data/api/request/productCatalogRequests';
import { useQuery } from '@tanstack/react-query';
import { ProductState } from './productState';

export function useGetProductCatalog(
  page: number,
  state?: ProductState,
  sellerFilter?: SellerFilterOption[]
) {
  const sellerIds = sellerFilter?.map((seller) => seller.sellerId);
  const { data, error, isLoading } = useQuery({
    queryKey: [
      cacheKeys.product.catalog,
      { page },
      { productStatus: state },
      sellerFilter,
    ],
    queryFn: () => getProducts({ pageNumber: page, state, sellerIds }),
  });

  return { data: data, error, isLoading };
}
